import { SetStateAction, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import cn from "classnames";

import { WizardButtons } from "shared/components/WizardNew/components/WizardButtons";
import { WizardData } from "shared/components/WizardNew/types";

import { SPLIT_TEST } from "shared/constants/split";
import { DEFAULT_MODE_WIZARD } from "shared/constants/wizard";

import { WizardStore, WizardType } from "shared/context/WizardStoreContext";

import { simplyClick } from "shared/helpers/analytics";
import { isSplitTestRequired } from "shared/helpers/view";
import { postWizardData, setStepperState } from "shared/helpers/wizard";

import { useWizard, WizardStep } from "shared/hooks/useWizard";

import styles from "@platformAssets/components/Wizard.module.scss";

type Props = { wizardData: WizardData };

const WizardWelcomeAboutYourself = ({ wizardData }: Props) => {
  const { t } = useTranslation("wizardNew");
  const [wizardStore, setWizardStore] = useContext(WizardStore);

  const navigate = useNavigate();
  const wizard = useWizard(wizardData);
  const { mode } = wizardData;

  const isSplitReducedWizardEnabled =
    mode === DEFAULT_MODE_WIZARD &&
    isSplitTestRequired(wizard.data, SPLIT_TEST.reducedWizard);

  const step = wizard[WizardStep.WelcomeStep2];

  const handleClick = async () => {
    await postWizardData({}, WizardStep.WelcomeStep2);

    // Remove after refactoring helpers
    setWizardStore(
      setStepperState(
        wizardStore,
        2,
        mode,
        isSplitReducedWizardEnabled
      ) as unknown as SetStateAction<WizardType>
    );

    step.analytics?.start?.forEach((item: string) => {
      simplyClick(item, null, false);
    });

    navigate(`/${step.nextStep}`);
  };

  return (
    <div className={styles.welcomeContainer}>
      <WizardButtons variant="welcome" userData={wizardData} showBack={false} />

      <div className={styles.welcome}>
        <div className={styles.wizardAnimationWrapper}>
          <div className={cn(styles.welcomeAnimation, styles.animation2)}>
            <div className={styles.row1} />
            <div className={styles.row2} />
            <div className={styles.row3} />
          </div>
        </div>

        <div className={styles.wizardInfoWrapper}>
          <div className={styles.welcomeTextWrapper}>
            <div>
              <div className={styles.welcomeTitle}>{t("block2.title")}</div>

              <div className={styles.welcomeDescription}>
                {t("block2.description")}
              </div>
            </div>
          </div>

          <div className={styles.btnWrap}>
            <button onClick={handleClick} className={styles.welcomeButton}>
              {t("block2.btn")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export { WizardWelcomeAboutYourself };
